<template>
 <div>
     <s-form :key="formKey" @submit="addItem">
        <div class="row fl-x fl-j-sb ml-1">
            <h2 class="head font-poppins-semibold  mt-3 text-primary">Testing of French Mini Straw</h2>
            <div>
                <btn class="px-4 mt-2 ml-1" style="cursor: pointer" @click="BackToHome">Back</btn>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="col-lg-2">
                        <validated-date-picker format="DD-MM-YYYY" label="Date" :disabled-date="disabledAfterToday"
                                               class="c-input-datepicker  text-black" v-model="model.test_date" :rules="rules.common"></validated-date-picker>
                    </div><div class="col-lg-2">
<!--                        <validated-select :options="sampleNoOption" label="Sample No"-->
<!--                                               class="c-input-select text-black field-required" v-model="model.sample_no" :rules="{required:true}"></validated-select>-->
                        <validated-input label="Sample No"
                                          class="text-black" v-model="model.sample_no"></validated-input>
                    </div><div class="col-lg-2">
                        <validated-input label="Lot No"
                                               class="text-black" v-model="model.lot_no" :rules="rules.positiveOnly" type="number"></validated-input>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-lg-2">
                        <validated-file-input :key="fileInputKey" label-text="Upload file" class="w-10r" v-model="model.test_report"></validated-file-input>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-lg-2">
                        <validated-input label="Remarks" class="text-black" v-model="model.remarks"></validated-input>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="fl-x fl-j-e">
                    <div class="btn-group">
                        <btn text="Save"  :loading="loading" loading-text="Saving..."  class="px-4"></btn>
                        <btn text="Cancel"  type="reset" @click="BackToHome" design="basic-b" class="px-4"></btn>
                    </div>
                </div>
            </div>
        </div>
</s-form>
     <div class="mt-4">
            <vue-table ref="table" :fields="fields" :url="listURL" :per-page="10" search-placeholder="Sample No">
                <template slot="test_report" slot-scope="props">
                    <a
                        v-if="props.rowData.test_report"
                        :href="props.rowData.test_report"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {{ getFileName(props.rowData.test_report) }}
                    </a>
                    <span v-else>-</span>
                </template>
            </vue-table>
        </div>
<!--     <div class="column fl-x mt-4"  v-if="viewData.length">-->
<!--        <div class="col-lg-12 ">-->
<!--                    <div class="card pl-0 pr-0 pb-0 ml-lg-auto">-->
<!--&lt;!&ndash;                        <div class="heading font-poppins-medium text-primary pt-3 mb-2 bg-2 fl-x-cc fs-lg&#45;&#45;1">Milk Disposal</div>&ndash;&gt;-->
<!--                        <table style="width:100%" class="c-table-1">-->
<!--                            <thead>-->
<!--                            <th class=""><h5 class=" w-100p bg-2  mb-0 text-left font-poppins-medium fs-lg-0 text-primary fl-y-tc">Test Date</h5></th>-->
<!--                            <th class=""><h5 class=" w-100p bg-2  mb-0 text-left font-poppins-medium fs-lg-0 text-primary fl-y-tc">Sample No</h5></th>-->
<!--                            <th class=""><h5 class=" w-100p bg-2  mb-0 text-left font-poppins-medium fs-lg-0 text-primary fl-y-tc">Lot No</h5></th>-->
<!--                            <th class=""><h5 class=" w-100p bg-2  mb-0 text-left font-poppins-medium fs-lg-0 text-primary fl-y-tc">Report</h5></th>-->
<!--                            <th class=""><h5 class=" w-100p bg-2  mb-0 text-left font-poppins-medium fs-lg-0 text-primary fl-y-tc">Remarks</h5></th>-->
<!--                            </thead>-->
<!--                            <tbody class="">-->
<!--                            <tr v-for="(item, i) in paginatedData" :key="i">-->
<!--                                <td>{{ item.test_date }}</td>-->
<!--                                <td>{{ item.sample_no }}</td>-->
<!--                                <td>{{ item.lot_no }}</td>-->
<!--                                <td>-->
<!--                                  <a-->
<!--                                    :href="item.test_report"-->
<!--                                    target="_blank"-->
<!--                                    rel="noopener noreferrer"-->
<!--                                    v-if="item.test_report"-->
<!--                                  >-->
<!--                                    {{ getFileName(item.test_report) }}-->
<!--                                  </a>-->
<!--                                  <span v-else>-</span>-->
<!--                                </td>-->
<!--                                <td>{{ item.remarks }}</td>-->

<!--                            </tr>-->
<!--                            </tbody>-->

<!--                        </table>-->
<!--                        <div class="pagination text-center" v-if="viewData.length">-->
<!--                            <btn-group class="ml-2">-->
<!--                              <btn class="mr-2" v-if="currentPage > 1" @click="prevPage"><img src="../../assets/web/icons/icon-left-arrow.png" style="width: 16px; height: 16px;" alt="<-" /></btn>-->
<!--                              <span class="font-poppins-small fs-lg-0 text-primary">Page {{ currentPage }} of {{ totalPages }}</span>-->
<!--                              <btn class="ml-2" v-if="currentPage < totalPages" @click="nextPage"><img src="../../assets/web/icons/icon-right-arrow.png" style="width: 16px; height: 16px;" alt="<-" /></btn>-->
<!--                                </btn-group>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import urls from '../../data/urls';
import axios from 'secure-axios';

export default {
    name: 'TestingofFrenchMiniStraw',
    data () {
        return {
            sampleNoOption: [
                { label: 'Medium', value: 'Medium' },
                { label: 'Small', value: 'Small' }
            ],
            loading: false,
            URL: urls.french_mini_straw.addEdit,
            listURL: urls.french_mini_straw.list,
            fields: [
                {
                    name: 'test_date',
                    title: 'Test Date'
                },
                {
                    name: 'sample_no',
                    title: 'Sample No'
                },
                {
                    name: 'lot_no',
                    title: 'Lot No'
                },
                {
                    name: '__slot:test_report',
                    title: 'Report'

                },
                {
                    name: 'remarks',
                    title: 'remarks'
                }
            ],
            viewData: [],
            // currentPage: 1,
            // itemsPerPage: 10,
            fileInputKey: 0,
            formKey: 0,
            model: {
                test_date: '',
                sample_no: '',
                lot_no: '',
                test_report: '',
                remarks: ''
            },
            rules: {
                positiveOnly: {
                    // required: true,
                    customValidator: (value) => {
                        return this.avoidNegetive(value);
                    }
                },
                common: {
                    required: false,
                    customValidator: (value) => {
                        return this.validationDate(value);
                    }
                }
            }
        };
    },
    // mounted () {
    //     this.loadData();
    // },
    // computed: {
    //     paginatedData () {
    //         const start = (this.currentPage - 1) * this.itemsPerPage;
    //         return this.viewData.slice(start, start + this.itemsPerPage);
    //     },
    //     totalPages () {
    //         return Math.ceil(this.viewData.length / this.itemsPerPage);
    //     }
    // },
    methods: {
        BackToHome () {
            this.$router.push({ path: '/quality-control/' });
        },
        // nextPage () {
        //     if (this.currentPage < this.totalPages) {
        //         this.currentPage++;
        //     }
        // },
        // prevPage () {
        //     if (this.currentPage > 1) {
        //         this.currentPage--;
        //     }
        // },
        getFileName (path) {
            if (!path) return '';
            return path.split('/').pop(); // Extracts the filename from a full path
        },
        // async loadData () {
        //     this.viewData = [];
        //     const response = await axios.get(urls.french_mini_straw.list);
        //     this.viewData = response.data.data;
        //     console.log('response', this.data);
        // },
        disabledAfterToday (date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today;
        },
        avoidNegetive (no) {
            const num = no;
            if (num < 0) {
                return 'Please enter a valid number';
            }
            return true;
        },
        validationDate () {
            const checkDate = this.model.test_date;

            const checkDateParts = checkDate.split('-');
            if (checkDateParts.length !== 3) {
                return 'Please enter a valid Test Date in the format DD-MM-YYYY.';
            }
            const checkDateDay = parseInt(checkDateParts[0], 10);
            const checkDateMonth = parseInt(checkDateParts[1], 10);
            const checkDateYear = parseInt(checkDateParts[2], 10);

            const checkDateObj = new Date(checkDateYear, checkDateMonth - 1, checkDateDay);

            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            if (checkDateObj > currentDate) {
                return 'Future Date not allowed.';
            }
            return true;
        },
        async addItem () {
            const hasData = Object.values(this.model).some(value => {
                if (Array.isArray(value)) {
                    return value.length > 0;
                }
                if (value instanceof File) {
                    return true;
                }
                return value !== null && value !== undefined && String(value).trim() !== '';
            });
            if (!hasData) {
                this.$notify(
                    'No data to save. Please enter at least one field.',
                    'Warning',
                    { type: 'warning' }
                );
                return;
            }
            try {
                this.loading = true;
                const response = await axios.form(this.URL, this.model);
                const result = response.data;
                if (result.success) {
                    this.$notify('Added Successfully', 'Success', { type: 'success' });
                    this.loading = false;
                    this.model.remarks = '';
                    this.model.lot_no = '';
                    this.model.purchase_type = '';
                    this.model.sample_no = '';
                    this.model.test_date = '';
                    this.model.test_report = '';
                    this.fileInputKey++;
                    this.formKey++;
                    this.$nextTick(() => {
                        if (this.$refs.table) {
                            this.$refs.table.refreshTable();
                        }
                    });
                    await this.$router.push({ path: '/testing-of-french-mini-straw/' });
                } else {
                    const errors = response.data.errors;

                    for (const key in errors) {
                        if (Object.prototype.hasOwnProperty.call(errors, key)) {
                            let errorMessage = '';
                            if (key === '__all__') {
                                errorMessage = `${errors[key]}`;
                            } else {
                                errorMessage = `${key}:  ${errors[key]}`;
                            }
                            this.$notify(errorMessage, 'Warning', { type: 'warning' });
                        }
                    }
                    this.loading = false;
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
